import React from 'react';
import { ColorBlindnessSimulator } from '../components/color-blindness-simulator/ColorBlindnessSimulator';
import '../components/color-blindness-simulator/ColorBlindnessSimulator.css';

export const ColorBlindnessSimulatorPage: React.FC = () => {
  return (
    <div className="page-container">
      <ColorBlindnessSimulator />
    </div>
  );
};
